<script>

/**
 * Section: Media Hero
 * -----------------------------------------------------------------------------
 * - Static section, this file simply exists to import styles.
 */

export default {
  name: 'MediaHero',
}
</script>

<style src="./media-hero.scss" lang="scss"></style>
